export default "__VITE_PUBLIC_ASSET__2b3f81d0__"